"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocaleSelector = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const constants_1 = require("@snapchat/sc-web-frame/lib/constants");
const web_i18n_1 = require("@snapchat/web-i18n");
const js_cookie_1 = __importDefault(require("js-cookie"));
const react_1 = require("react");
const LocaleSelector_module_css_1 = __importDefault(require("./LocaleSelector.module.css"));
const web_env_1 = require("@snapchat/web-env");
const LANGUAGE_COOKIE_NAME = "sc-language";
function getScopedCookieDomain(domain) {
    const subDomain = domain.substring(domain.indexOf("."));
    return subDomain.substring(0, subDomain.includes(":") ? subDomain.indexOf(":") : subDomain.length);
}
/**
 * Dropdown menu to control page locale
 */
function LocaleSelector({ locale = web_i18n_1.DEFAULT_LOCALE, localeChange }) {
    const handleLocaleChange = (0, react_1.useCallback)((event) => {
        const newLocale = event.target.value || web_i18n_1.DEFAULT_LOCALE;
        js_cookie_1.default.set(LANGUAGE_COOKIE_NAME, newLocale, {
            expires: 365,
            secure: true,
            domain: getScopedCookieDomain((0, web_env_1.getDocument)()?.location.host || ""),
        });
        localeChange?.((0, web_i18n_1.getLocale)(newLocale));
    }, [localeChange]);
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "localeSelector", className: LocaleSelector_module_css_1.default.label, children: "Language" }), (0, jsx_runtime_1.jsx)("select", { name: "localeSelector", className: LocaleSelector_module_css_1.default.localeSelector, onChange: handleLocaleChange, value: locale, "data-testid": "localeSelector", children: web_i18n_1.ALL_LOCALES.filter((key) => key in constants_1.LOCALE_ARRAY).map((key) => ((0, jsx_runtime_1.jsx)("option", { value: constants_1.LOCALE_ARRAY[key].lang, children: constants_1.LOCALE_ARRAY[key].name }, constants_1.LOCALE_ARRAY[key].lang))) })] }));
}
exports.LocaleSelector = LocaleSelector;
//# sourceMappingURL=LocaleSelector.js.map